export class UnknownVariantError extends Error {
  constructor(public readonly variant: {}) {
    super(JSON.stringify(variant));
    this.name = "UnknownVariantError";
  }
}
